import { Middleware } from "redux";
import {
  setAuditPrevMenuCategory,
  setAuditPrevMenuItem,
} from "../actions/auditActions";

const ACTION_EDIT_ORDERING_CATEGORIES_REQUESTED =
  "ACTION_EDIT_ORDERING_CATEGORIES_REQUESTED";
const ACTION_DELETE_ORDERING_CATEGORY_REQUESTED =
  "ACTION_DELETE_ORDERING_CATEGORY_REQUESTED";
const ACTION_EDIT_ORDERING_ITEM_REQUESTED =
  "ACTION_EDIT_ORDERING_ITEM_REQUESTED";
const ACTION_DELETE_ORDERING_ITEM_REQUESTED =
  "ACTION_DELETE_ORDERING_ITEM_REQUESTED";

export const auditStateCaptureMiddleware: Middleware = (store) => (next) => (action: any) => {
  switch (action.type) {
    case ACTION_EDIT_ORDERING_CATEGORIES_REQUESTED:
    case ACTION_DELETE_ORDERING_CATEGORY_REQUESTED: {
      const state = store.getState() as any;
      const id = action.type === ACTION_DELETE_ORDERING_CATEGORY_REQUESTED
        ? action.payload
        : action.payload?.id;
      const prevRecord =
        state.orderingMenuCategoriesReducer?.categoriesById?.[id];
      if (prevRecord) {
        store.dispatch(setAuditPrevMenuCategory(prevRecord));
      }
      break;
    }

    case ACTION_EDIT_ORDERING_ITEM_REQUESTED:
    case ACTION_DELETE_ORDERING_ITEM_REQUESTED: {
      const state = store.getState() as any;
      const id =
        action.type === ACTION_DELETE_ORDERING_ITEM_REQUESTED
          ? action.payload
          : action.payload?.id;
      const itemsState = state.orderingMenuItemsReducer;
      const prevRecord: any =
        itemsState?.current?.itemsById?.[id] ?? itemsState?.itemsById?.[id];
      if (prevRecord) {
        store.dispatch(setAuditPrevMenuItem(prevRecord));
      }
      break;
    }
  }

  return next(action);
};
